module.exports = __webpack_public_path__ + "static/quoteHeadshot-08a55363fe72324c85e4c9c59bda30a9.png";